if (!customElements.get('home-countdown')) {
  class HomeCountdown extends HTMLElement {
    connectedCallback() {
      this.endTime = Date.parse(this.dataset.endDate);
      this.values = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]'),
      };
      this.status = this.querySelector('[data-countdown-status]');

      this.updateCountdown();

      if (Number.isFinite(this.endTime) && this.endTime > Date.now()) {
        this.interval = window.setInterval(() => this.updateCountdown(), 1000);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    updateCountdown() {
      const remaining = Number.isFinite(this.endTime) ? Math.max(0, this.endTime - Date.now()) : 0;
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      this.values.days.textContent = String(days).padStart(2, '0');
      this.values.hours.textContent = String(hours).padStart(2, '0');
      this.values.minutes.textContent = String(minutes).padStart(2, '0');
      this.values.seconds.textContent = String(seconds).padStart(2, '0');

      if (remaining === 0) {
        window.clearInterval(this.interval);
        this.status.textContent = Number.isFinite(this.endTime) ? 'This offer has ended.' : 'Set a countdown end date in the Theme Editor.';
      }
    }
  }

  customElements.define('home-countdown', HomeCountdown);
}
